import React, { useEffect } from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, content }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen || !content) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const renderContent = () => {
    if (content.type === 'inquiry') {
      return (
        <div className="modal-body">
          <i className="fas fa-phone-alt modal-icon"></i>
          <h3>Interested in this service?</h3>
          <p>Please call us for more information and personalized consultation about this service.</p>
          <div className="modal-actions">
            <a href="tel:+918160569755" className="book-now-btn">
              <i className="fas fa-phone"></i>
              Call Now: +91 8160569755
            </a>
            <button className="close-modal-btn" onClick={onClose}>
              <i className="fas fa-times"></i>
              Close
            </button>
          </div>
        </div>
      );
    }

    if (content.type === 'product') {
      return (
        <div className="modal-body">
          <i className="fas fa-hourglass-half modal-icon"></i>
          <h3>Coming Soon!</h3>
          <p>Our product section is under development. Please check back later for exciting offerings!</p>
          <div className="modal-actions">
            <button className="close-modal-btn" onClick={onClose}>
              <i className="fas fa-times"></i>
              Close
            </button>
          </div>
        </div>
      );
    }

    if (content.type === 'service') {
      return (
        <div className="modal-body">
          <h2>{content.title}</h2>
          <div className="service-modal-header">
            <span className="service-price">{content.price}</span>
            <span className="service-duration">{content.duration}</span>
          </div>
          <p className="service-description">{content.description}</p>
          
          {content.includes && (
            <>
              <h3>What's Included:</h3>
              <ul className="service-includes">
                {content.includes.map((item, index) => (
                  <li key={index}><i className="fas fa-star"></i> {item}</li>
                ))}
              </ul>
            </>
          )}
          
          {content.process && (
            <>
              <h3>Process:</h3>
              <p className="service-process">{content.process}</p>
            </>
          )}
          
          <div className="modal-actions">
            <button className="book-now-btn" onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
                onClose();
              }
            }}>
              <i className="fas fa-calendar-plus"></i>
              Book Now
            </button>
            <button className="close-modal-btn" onClick={onClose}>
              <i className="fas fa-times"></i>
              Close
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="modal-body">
        <h3>{content.title}</h3>
        <p>{content.content}</p>
        <div className="modal-actions">
          <button className="close-modal-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
            Close
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="modal" onClick={handleBackdropClick}>
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        {renderContent()}
      </div>
    </div>
  );
};

export default Modal;